/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'two-arrow': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M5.175 17.824a.6.6 0 010-.847l6-6 .091-.076a.6.6 0 01.757.076l6 6 .077.093a.6.6 0 01-.831.831l-.094-.077-5.576-5.576-5.576 5.576a.6.6 0 01-.848 0zm0-5a.6.6 0 010-.847l6-6 .091-.076a.6.6 0 01.757.076l6 6 .077.093a.6.6 0 01-.831.831l-.094-.077L11.6 7.248l-5.576 5.576a.6.6 0 01-.848 0z" _fill="#0077C8"/>'
  }
})
